import React, { useEffect, useRef, useState } from "react";
import "./GsaUserAgentSelectHeader.scss";
import DownArrow from "../../assets/images/caret-down-outline.svg";
import closeIcon from "../../assets/images/close-outline.svg";
import {
  doGsaAgentSelect,
  isStringEmpty,
  validatAgentCodePattern,
} from "./GsaUserAgentSelectUtil";
import MESSAGES from "../../constants/Messages";
import CommonInput from "../../common/Resusable/CommonInput";
import { Divider } from "../../common/Divider";
import { PrimaryButton, SecondaryButton } from "../../common/Buttons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const SwitchAgentPopover = ({
  agentName,
  agentNumber,
  showGsaAgentPopup,
  setShowGsaAgentPopup,
  setIsLoading,
  t,
  gsaAgentData,
  setToGsaAgent,
  isNoSubHeaderCase
}) => {
  const history = useHistory();
  const [agentCode, setAgentCode] = useState("");
  const [error, setError] = useState("");


  const validateAgentCode = (AgentCode) => {
    if (AgentCode && !validatAgentCodePattern(AgentCode)) {
      setError(t(MESSAGES.VALID_AGENT_CODE, { ns: "errors" }));
    }
  };

  const togglePopup = (isAgentChangeCase) => {
    setAgentCode("");
    setError("");
    setShowGsaAgentPopup((prev) => !prev);
    const currentUrl = window.location.pathname;
    if (isAgentChangeCase) {
      window.location.href = currentUrl;
    }
  };

  const getAgentInitialCircle = () => {
    const initialLetters = agentName
      ?.trim()
      ?.split(" ")
      ?.map((name) => name?.charAt(0))
      .join("");
    return (
      <div className="gsauser-initialscircle">
        {initialLetters?.slice(0, 2)}
      </div>
    );
  };

  const popupRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowGsaAgentPopup(false);
      }
    };

    if (showGsaAgentPopup) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showGsaAgentPopup, setShowGsaAgentPopup]);

  const handleSwitchButtonClick = async () => {
    const isSuccess = await doGsaAgentSelect(
      agentCode,
      gsaAgentData,
      setIsLoading,
      setError,
      setToGsaAgent,
      history,
      t,
      true
    );
    if (isSuccess) {
      togglePopup(true);
    }
  };

  const handleViewDashButtonClick = () => {
    togglePopup()
    history.push('/dashboard')
   
  }
  return (
    <div className="gsa-header-wrapper">
      <div className="gsauserselect-container">
        <button className={`gsauserselect-button ${isNoSubHeaderCase ? "no-sub-header" : ""}`} onMouseDown={() => togglePopup(false)}>
          {agentName ? (
            <>
              {getAgentInitialCircle()}
              <span className="agent-name-number">
                {agentName} - {agentNumber}
              </span>
            </>
          ) : (
            <span className="agent-name-number">{agentNumber}</span>
          )}
          <img src={DownArrow} alt="dropdown" className={`down-icon ${showGsaAgentPopup ? "up" : ""}`} />

        </button>
        <div
          className={`popup ${showGsaAgentPopup ? "open" : ""}`}
          ref={popupRef}
        >
          <div className="gsauserselect-popup-content">
            <div className="gsauserselect-popup-header">
              {t('COMMON.SWITCH_AGENT')} <img src={closeIcon} onClick={() => togglePopup(false)} />
            </div>
            <Divider coverage="100%" />
            <div className="input-container">
              <div className="form-group">
                <CommonInput
                  type='text'
                  id="AgentCode"
                  value={agentCode}
                  maxLength={11}
                  label={t("COMMON.AGT_CODE")}
                  onChange={(e) => {
                    if (e.target.value.length <= 11) {
                      setAgentCode(e.target.value);
                    }
                  }}
                  onBlur={(e) => {
                    validateAgentCode(e.target.value);
                  }}
                  onFocus={() => {
                    setError("");
                  }}
                  error={!isStringEmpty(error) ? error : ""}
                />
              </div>
            </div>
            <div className="gsa-popup-footer">
              <SecondaryButton
                label={t("HEADER.VIEW_DASH")}
                onClick={handleViewDashButtonClick}
              />
              <PrimaryButton
                label={t('COMMON.SWITCH')}
                onClick={handleSwitchButtonClick}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwitchAgentPopover;